module.exports = __webpack_public_path__ + "fa-regular-400.6534c603e0892488132a";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-regular-400.ttf
// module id = ../../../../../src/scss/webfonts/fa-regular-400.ttf
// module chunks = styles